// extracted by mini-css-extract-plugin
module.exports = {"root":"src_root__AuRwO"};